import { render, staticRenderFns } from "./operateLog.vue?vue&type=template&id=964b53ce&scoped=true"
import script from "./operateLog.vue?vue&type=script&lang=js"
export * from "./operateLog.vue?vue&type=script&lang=js"
import style0 from "./operateLog.vue?vue&type=style&index=0&id=964b53ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964b53ce",
  null
  
)

export default component.exports